import React from 'react';
import { motion } from 'framer-motion';
import './About.css';

const pillars = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M4.9 19.1L7 17M17 7l2.1-2.1" />
      </svg>
    ),
    title: 'Engineering Excellence',
    body: 'Mono & bifacial modules engineered in-house with TOPCon cell tech — delivering 22.8%+ conversion efficiency, field-proven across deserts, rooftops, and floating arrays.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M12 2L3 7v6c0 5 4 9 9 9s9-4 9-9V7l-9-5z" />
        <path d="M9 12l2 2 4-4" />
      </svg>
    ),
    title: 'Certified by BIS & MNRE',
    body: 'IEC 61215, IEC 61730, and BIS certified. MNRE-approved and ALMM-listed — compliant with every major Indian utility, DISCOM, and tendering framework.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M3 12c2-6 8-9 14-7 6 2 6 10 0 14-6 4-12 1-14-7z" />
        <path d="M12 8v4l3 2" />
      </svg>
    ),
    title: '25-Year Warranty',
    body: 'Industry-leading linear performance warranty — guaranteed ≥84.8% output at year 25. Backed by a pan-India service network with on-site support teams across NCR, UP, and Haryana.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M2 12h3l3-8 4 16 3-8h3" />
      </svg>
    ),
    title: 'Smart Monitoring',
    body: 'AI-driven remote diagnostics via our Helios platform — panel-level telemetry, automated fault detection, and predictive maintenance around the clock.',
  },
];

export default function About() {
  return (
    <section id="about" className="about">
      <div className="container about-inner">
        <motion.div
          className="about-lead-col"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
        >
          <span className="eyebrow">Who we are</span>
          <h2 className="section-title">
            A decade of <span className="accent">solar innovation</span>,
            built to last a generation.
          </h2>
          <p className="section-lead">
            Founded in 2013, Global Sun Energy Solution designs and manufactures
            end-to-end solar ecosystems — from high-efficiency modules to grid-scale
            inverters and intelligent storage. We operate GW-scale facilities across
            Delhi, Haryana, and Uttar Pradesh, serving customers in 28+ Indian states.
          </p>
          <div className="about-actions">
            <a href="#projects" className="btn btn-primary">See Our Projects</a>
            <a href="#process" className="btn btn-ghost">How We Build</a>
          </div>
        </motion.div>

        <div className="about-pillars">
          {pillars.map((p, i) => (
            <motion.div
              key={p.title}
              className="pillar glass"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
            >
              <div className="pillar-ico">{p.icon}</div>
              <h3>{p.title}</h3>
              <p>{p.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
